// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609100551/js/" + chunkId + "." + {"44":"9797e62d","225":"74cd6e49","481":"36a1fcd2","486":"0887d38a","770":"d18283f4"}[chunkId] + ".0.17603227388073217.chunk.js";
};